import DeleteShopCategoryRequestModelBase from '../_generated/modelBases/delete-shop-category-request-model-base';

export default class DeleteShopCategoryRequestModel extends DeleteShopCategoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
